import style from '../css/Report.module.css';

function Header() {
    return (
        <div className={style.header}>
            <div className={style.headerContainer}>
                <a href='https://report.elite-on.com/' className={style.headerTitle}>
                    <img src='logo2.png' alt='logo' className={style.headerIcon}></img>
                </a>
            </div>
        </div>
    )
}
export default Header;